module.exports = __webpack_public_path__ + "static/media/ribbon.024536d1.png";